import { useEffect } from "react";

import {
  GroupRegistrationError,
  GroupRegistrationText,
} from "@/constants/Schedule";
import { useToast } from "@/hooks/useToast";
import { captureException } from "@/services/AppMonitor";

interface UseGroupDetailsErrorHandlerArgs {
  error: unknown;
  groupId?: string;
  isError: boolean;
  // called to close the screen when the fetch fails, so it isn't stuck on a spinner
  onError: () => void;
  patientId?: string;
}

// Shared v2 group-details error handling: a failed fetch leaves data undefined, which
// would otherwise keep the details screen on a spinner. Reports to Datadog, shows an
// error toast, and closes the screen.
const useGroupDetailsErrorHandler = ({
  error,
  groupId,
  isError,
  onError,
  patientId,
}: UseGroupDetailsErrorHandlerArgs) => {
  const { showToast } = useToast();

  useEffect(() => {
    if (!isError) return;
    captureException(
      new Error(GroupRegistrationError.GroupDetailsLoadError, { cause: error }),
      { context: { groupId, patientId } },
    );
    showToast({
      text: GroupRegistrationText.GroupDetailsLoadError,
      variant: "error",
    });
    onError();
  }, [error, groupId, isError, onError, patientId, showToast]);
};

export default useGroupDetailsErrorHandler;
